import { render } from "./DashboardSpaceSummary.vue?vue&type=template&id=845b71da"
import script from "./DashboardSpaceSummary.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceSummary.vue?vue&type=script&lang=js"
script.render = render

export default script